// removed by extract-text-webpack-plugin
module.exports = {"button":"eDj3","s2":"zwID","position":"_3Z-s","active":"_3-q5","blue":"_2ItJ","green":"_2U5l","red":"_2lCf","s0":"_25_s","s1":"_2yLT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/keyboard/button/index.less
// module id = 267
// module chunks = 0